import axios from '@/libs/api.request'
export const getMethod = (params) => {
  return axios.request({
    url: '/common/method',
    method: 'GET',
    params
  })
}
export const getDetails = (id) => {
  return axios.request({
    url: `/common/method/${id}`,
    method: 'GET'
  })
}
export const del = (id) => {
  return axios.request({
    url: `/common/method/${id}`,
    method: 'DELETE'
  })
}
export const update = (data) => {
  return axios.request({
    url: `/common/method/${data.id}`,
    method: 'PUT',
    data
  })
}
export const add = (data) => {
  return axios.request({
    url: '/common/method',
    method: 'POST',
    data
  })
}
